const RESOURCE_NAME = '/units-helper';

export default axios => ({
	getTypes(params) {
		return axios.get(`${RESOURCE_NAME}/types`, {params});
	},
	getXtypes(params) {
		return axios.get(`${RESOURCE_NAME}/xtypes`, {params});
	},
	getHwTypes(params) {
		return axios.get(`${RESOURCE_NAME}/hw-types`, {params});
	},
	getIcons(params) {
		return axios.get(`${RESOURCE_NAME}/icons`, {params});
	},
	getHwTypesSettings(params) {
		return axios.get(`${RESOURCE_NAME}/hw-types-settings`, {params});
	},
	getChassisTypes(params) {
		return axios.get(`${RESOURCE_NAME}/chassis-types`, {params});
	},
	getUnitsOfMeasures(params) {
		return axios.get(`${RESOURCE_NAME}/units-of-measures`, {params});
	}
});